import { menuActivePeriodsFetcher } from '@library/menu-service'

type MenuActivePeriod = {
  period_id: string
}

export const getMenuByPeriodId = async (
  periodId: string,
): Promise<'primary' | 'secondary' | 'tertiary' | null> => {
  const activePeriods = await menuActivePeriodsFetcher()
  const menuActivePeriodsData = activePeriods.data as MenuActivePeriod[]

  const menuIndex = menuActivePeriodsData.findIndex((menu) => menu.period_id === periodId)

  if (menuIndex === 0) return 'primary'
  if (menuIndex === 1) return 'secondary'
  if (menuIndex === 2) return 'tertiary'

  return null
}
